module.exports = __webpack_public_path__ + "img/logo-bar-zum-schmutzigen-hobby.20358e20.svg";